<script setup lang="ts">
import { useHead } from "@unhead/vue"
import { computed } from "vue"
import { PackageSubscriptionCard, ProfileUpdateForm } from "@/components"
import { useTranslation } from "@/composables"
import { SidebarLayout } from "@/layouts"
import { useAuthStore } from "@/stores/authStore"

definePage({
  meta: {
    requiresAuth: true,
  },
})

const { t } = useTranslation()
const authStore = useAuthStore()

useHead({ title: t("profile_page.title") })

const packageSubscription = computed(() => authStore.user?.packageSubscription)
</script>

<template>
  <SidebarLayout>
    <template #header>
      {{ t("profile_page.title") }}
    </template>

    <template #content>
      <div class="container my-6">
        <PackageSubscriptionCard v-if="packageSubscription?.packageSubscriptionId" :package-subscription="packageSubscription" class="mb-10" />
        <ProfileUpdateForm />
      </div>
    </template>
  </SidebarLayout>
</template>
